// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
// jQuery - JavaScript library for DOM manipulation, event handling, etc.
import $ from 'jquery';

// Rails UJS - Handles Unobtrusive JavaScript for Rails (e.g., AJAX, form submissions)
Rails.start();
// Turbolinks - Speeds up page loads by using AJAX to fetch pages
Turbolinks.start();
// ActiveStorage - Handles direct uploads for Rails Active Storage
ActiveStorage.start();
// Import jQuery explicitly and attach it to the global `window` object
// This ensures jQuery is available for inline scripts, non-module scripts, and legacy code
window.$ = window.jQuery = $;

// Import Moment.js
import moment from 'moment';
window.moment = moment; // Make moment available globally for daterangepicker and other legacy scripts

// Import DateRangePicker
import 'daterangepicker';

// ActionCable - WebSocket framework for real-time features in Rails
import "channels";

// Cocoon - A gem for handling nested forms dynamically in Rails
import "@nathanvda/cocoon";

// Bootstrap - Frontend framework for styling & components
import "bootstrap";

// Rich Text Editor
import "@rails/actiontext"
import "trix"

// Driver.js CSS for tour functionality
import 'driver.js/dist/driver.css'

// Canada Post API integration for autofilling address fields
import setupAddressAutocomplete from "./canada_post";
window.setupAddressAutocomplete = setupAddressAutocomplete;

// Common Code to Pick Date Range within a single field in Search Forms.
import setupDateRangePickerSearch, { setupSingleDatePicker } from "./date_range_search";
window.setupDateRangePickerSearch = setupDateRangePickerSearch;
window.setupSingleDatePicker = setupSingleDatePicker;

// Take the element id's from different forms and call the select2 on them
import initializeSelect2ForElements, { initializeReportingSelect2 } from "./select2_dropdown.js";
window.initializeSelect2ForElements = initializeSelect2ForElements;
window.initializeReportingSelect2 = initializeReportingSelect2;

// Pace restarts on history.pushState by default, which conflicts with
// Turbolinks back/forward cache restores and leaves the bar stuck mid-way.
window.paceOptions = {
  restartOnPushState: false
};

// Importing additional JavaScript dependencies for UI enhancements and functionality
import '../app-assets/vendors/js/vendors.min.js'
import "./turbolinks_pace";
import '../app-assets/vendors/js/charts/jquery.sparkline.min.js'
import '../app-assets/vendors/js/forms/select/select2.full.min.js'
import '../app-assets/vendors/js/forms/validation/jqBootstrapValidation.js'
import '../app-assets/vendors/js/pickers/pickadate/picker.js'
import '../app-assets/vendors/js/pickers/pickadate/picker.date.js'
import '../app-assets/vendors/js/forms/toggle/switchery.min.js'
import '../app-assets/vendors/js/extensions/jquery.knob.min.js'
import '../app-assets/js/scripts/extensions/knob.js'
import '../app-assets/vendors/js/charts/raphael-min.js'
import '../app-assets/vendors/js/charts/jvector/jquery-jvectormap-2.0.3.min.js'
import '../app-assets/vendors/js/charts/jvector/jquery-jvectormap-world-mill.js'
import '../app-assets/data/jvector/visitor-data.js'

// import '../app-assets/vendors/js/charts/chart.min.js'

// Ensure the script runs only after the DOM is fully loaded
document.addEventListener("DOMContentLoaded", async () => {
  try {
    // Dynamically import Unslider after jQuery is fully initialized
    // This prevents the "Unslider needs jQuery" warning, as Unslider tries to use jQuery immediately
    await import('../app-assets/vendors/js/extensions/unslider-min.js');
  } catch (err) {
    console.error('Failed to load Unslider:', err);
  }
});

import '../app-assets/vendors/js/timeline/horizontal-timeline.js'
import '../app-assets/js/core/app-menu.js'
import '../app-assets/js/core/app.js'
import '../app-assets/js/scripts/ui/breadcrumbs-with-stats.js'
import '../app-assets/js/scripts/pages/dashboard-analytics.js'
import '../app-assets/js/scripts/pages/account-setting.js'

// import '../app-assets/vendors/js/extensions/interactions.min.js'
import '../app-assets/js/core/libraries/jquery_ui/jquery-ui.min.js'

import '../app-assets/vendors/js/forms/quill/quill.js'
import '../app-assets/vendors/js/extensions/dragula.min.js'

import '../app-assets/vendors/js/gallery/masonry/masonry.pkgd.min.js'
import '../app-assets/vendors/js/gallery/photo-swipe/photoswipe.min.js'
import '../app-assets/vendors/js/gallery/photo-swipe/photoswipe-ui-default.min.js'

import '../app-assets/js/scripts/ui/breadcrumbs-with-stats.js'
import '../app-assets/js/scripts/pages/app-todo.js'
import '../app-assets/js/scripts/forms/select/form-select2.js'

// //= require chartkick
// //= require Chart.bundle

// Import global SCSS stylesheet for the application
import '../stylesheets/application.scss'
